import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class SiderService {

    componentLoader = new Subject;

    isHide = true;

    rooterChange;

    constructor(
        private router: Router
    ) { }

    init() {
        this.rooterChange = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.isHide = true;
            }
        });
    }

    open() {
        this.isHide = false;
    }

    close() {
        this.isHide = true;
    }

}